import { Empty, List, Space } from 'antd';
import React, { useContext, useEffect } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import AsyncWrapper from '@/components/AsyncWrapper';
import {
  getReportDetailExternal,
  getReportImg,
  requestUserMoremeReportList,
} from '@/models/moreme';
import { sleep } from '@/utils/common';
import { ReloadableAvatar } from '../Avatar';
import PosButton from '../PosButton';

export type Props = {
  username: string;
};

const MoremeUserReportList: React.FC<Props> = ({ username }: Props) => {
  const [, , helpers] = useContext(BaseInfoContext);
  const { payload, send, loading, error } = requestUserMoremeReportList();

  const request = (page = 1) => {
    send({
      pathVars: {
        username: username,
      },
      params: { limit: 6, page },
    }).then(data => {
      console.log(data);
    });
  };

  useEffect(() => {
    if (username) {
      request(1);
    }
  }, [username]);

  return (
    <>
      <AsyncWrapper loading={loading} error={error} render={!!payload}>
        {() => {
          const list = payload.list;
          const page = payload.page;
          if (!list || !list.length) {
            return <Empty description={'没有记录'} />;
          }
          return (
            <>
              <List
                loading={loading}
                itemLayout="horizontal"
                size={'small'}
                loadMore={
                  <div className={'align-flex-horizontal-center'} style={{ paddingTop: 15 }}>
                    <PosButton
                      disabled={page.current === 1}
                      loading={loading}
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        request(page.current - 1);
                      }}>
                      上一页
                    </PosButton>
                    <PosButton
                      disabled={page.current === page.pages}
                      loading={loading}
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        request(page.current + 1);
                      }}>
                      下一页
                    </PosButton>
                  </div>
                }
                dataSource={list}
                renderItem={record => (
                  <List.Item
                    actions={
                      [
                        // record.orderSn ? (
                        //   <PosButton
                        //     key={'detail'}
                        //     onClick={() => {
                        //       helpers.showOrderModal({
                        //         orderSn: record.orderSn,
                        //       });
                        //     }}>
                        //     订单
                        //   </PosButton>
                        // ) : null,
                      ]
                    }>
                    <List.Item.Meta
                      avatar={
                        <ReloadableAvatar
                          shape="square"
                          size={50}
                          src={`${getReportImg(record.imgPrefix, '0', 200)}`}
                          retry={9}
                          srcStrategy={async (src, retry) => {
                            if (retry === 1) {
                              await getReportDetailExternal(record.moremeCgid);
                            }
                            await sleep(230);
                            return src.replace(/,w_\d+$/, `,w_20${retry}`);
                          }}
                        />
                      }
                      title={
                        <>
                          Score {record.score} - Age {record.skinAge} - Type {record.faceType}
                          {/* {getBalanceLogTypeDesc(record)}{' '}
                          <Typography.Text type={record.value > 0 ? 'danger' : 'success'} strong>
                            {record.value > 0 ? <PlusOutlined /> : <MinusOutlined />}
                          </Typography.Text>
                          <Price
                            value={Math.abs(record.value)}
                            type={record.value > 0 ? 'primary' : 'green'}
                          />
                          {record.cost > 0 && record.value > record.cost && (
                            <Typography.Text style={{ marginLeft: 10, opacity: 0.8 }}>
                              [充
                              <Price value={record.cost} />送
                              <Price
                                value={new BigNumber(record.value).minus(record.cost).toNumber()}
                              />
                              ]
                            </Typography.Text>
                          )} */}
                        </>
                      }
                      description={
                        <Space direction={'vertical'} size={3}>
                          <Space>
                            <div className={'emphasize'}>Pore</div>
                            <div className={''}>NUM: {record.poreNum}</div>
                            <div className={''}>PCT: {record.pornPercentage}</div>
                          </Space>
                          <div className={''}>
                            <Space>
                              <div className={'emphasize'}>Blackhead</div>
                              <div className={''}>NUM: {record.blackheadNum}</div>
                              <div className={''}>SIZE: {record.blackheadSize}</div>
                              <div className={''}>PCT: {record.blackheadPercentage}</div>
                            </Space>
                          </div>
                          <div className={''}>
                            <Space>
                              <div className={'emphasize'}>Sensativity</div>
                              <div className={''}>AREA: {record.sensativityArea}</div>
                              <div className={''}>PCT: {record.sensativityAreaPercentage}</div>
                            </Space>
                          </div>
                          <div className={''}>
                            <Space>
                              <div className={'emphasize'}>Stain</div>
                              <div className={''}>NUM: {record.stainNum}</div>
                              <div className={''}>AREA: {record.stainArea}</div>
                              <div className={''}>PCT: {record.stainPercentage}</div>
                            </Space>
                          </div>
                          <div className={''}>
                            <Space>
                              <div className={'emphasize'}>Wrinkle</div>
                              <div className={''}>NUM: {record.wrinkleNum}</div>
                              <div className={''}>LEN: {record.wrinkleLength}</div>
                              <div className={''}>PCT: {record.wrinklePercentage}</div>
                            </Space>
                          </div>

                          <div>{record.addTime}</div>
                        </Space>
                      }
                    />
                  </List.Item>
                )}
              />
            </>
          );
        }}
      </AsyncWrapper>
    </>
  );
};

export default MoremeUserReportList;
